// extracted by mini-css-extract-plugin
export default {"listItem":"skills-gap-report-modal_listItem__SOLjx","card":"skills-gap-report-modal_card__dKrwo","list":"skills-gap-report-modal_list__nWtxP"};